import React from 'react';
import { Link } from "gatsby"

export default ({ to, className, children }) => {
    const isExternal = to.startsWith('https://') || to.startsWith('http://') || to.startsWith('www.');
    if (isExternal) return <a className={className} href={to} target="_blank" rel="noopener noreferrer">{children}</a>

    return <Link className={className} to={to}>{children}</Link>
}
